export var cacheCurrencyFormatter = function cacheCurrencyFormatter(lng) {
  var cache = new Map();
  return function (currency) {
    if (cache.has(currency)) {
      return cache.get(currency);
    }
    var formatter = new Intl.NumberFormat(lng, {
      style: 'currency',
      currency: currency
    });
    cache.set(currency, formatter);
    return formatter;
  };
};